module.exports = __webpack_public_path__ + "static/media/default_cover.043b9f51.jpg";